import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import CompanyInsuranceCarrier from './CompanyInsuranceCarrier';

class EmployeeInsuranceNumber extends DomainObject {
  externalId;
  companyInsuranceCarrier;

  _relations = {
    companyInsuranceCarrier: CompanyInsuranceCarrier
  };

  constructor(other) {
    super();

    makeObservable(this, {
      externalId: observable,
      companyInsuranceCarrier: observable
    });

    this.merge(other);
  }
}

export default EmployeeInsuranceNumber;
